// frontend/src/pages/BuyerDashboard.jsx
import { useEffect, useState } from "react";
import API from "../services/api";

export default function BuyerDashboard() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await API.get("/buyer/products", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setProducts(res.data.products);
      } catch (err) {
        console.error("Failed to fetch products:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) return <h2>Loading your purchased products...</h2>;

  return (
    <div style={{ padding: 20 }}>
      <h1>Your Purchased Products</h1>
      {products.length === 0 && <p>You have not bought any products yet.</p>}
      <ul>
        {products.map((p) => (
          <li key={p.id} style={{ marginBottom: 10 }}>
            {p.name} &nbsp;
            <button
              onClick={() => window.open(p.file_url, "_blank")}
              style={{
                padding: "5px 10px",
                background: "green",
                color: "#fff",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              Download
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}